import React from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

export function Modal({ open, onClose, title, children, testid, centerTitle }) {
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-end justify-center py-4 sm:items-center sm:py-8" data-testid={testid}>
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]" onClick={onClose} />
      <div className="modal-scroll relative z-10 my-auto max-h-[90vh] w-full overflow-y-auto rounded-t-3xl border border-xmas-gold/20 bg-xmas-navycard p-5 shadow-2xl sm:max-w-2xl sm:rounded-3xl sm:p-7">
        <div className={`relative mb-4 flex items-start gap-3 ${centerTitle ? "justify-center" : "justify-between"}`}>
          <h2 className={`font-display text-2xl text-xmas-gold ${centerTitle ? "text-center" : ""}`}>{title}</h2>
          <button onClick={onClose} data-testid="modal-close" className={`shrink-0 rounded-full p-1 text-xmas-slate hover:text-xmas-snow ${centerTitle ? "absolute right-0 top-0" : ""}`} aria-label="close">
            <X className="h-6 w-6" />
          </button>
        </div>
        {children}
      </div>
    </div>,
    document.body
  );
}
